import React, { useState, useEffect,useRef, useContext, Component } from 'react';
import { useNavigate,Link } from "react-router-dom";
import TestingHeader from './TestingHeader';
import TestingFooter from './TestingFooter';
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim"; // lightweight version
import { motion, useInView, animate } from "framer-motion";
import spaceAudio from '../../assets/audio/space.mp3'; // ✅ Correct way to import audio
import scrollSound from '../../assets/audio/scroll.mp3'; // ✅ Correct way to import audio
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation, Thumbs, Pagination } from "swiper/modules";

 const TestingAbout = () => {


    const [hide, setHide] = useState(false);



  const bgAudioRef = useRef(null);
  const scrollAudioRef = useRef(null);
  const playedScroll = useRef(false);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    const bg = bgAudioRef.current;
    const scrollFx = scrollAudioRef.current;
    if (!bg || !scrollFx) return;

    // ✅ Background Audio setup
    bg.loop = true;
    bg.volume = 0.2;
    bg.preload = "auto";
    bg.currentTime = 0.3;

    bg.play()
      .then(() => setIsPlaying(true))
      .catch(() => {
        console.log("Autoplay blocked — click once to start background audio.");
        const startBg = () => {
          bg.play().then(() => setIsPlaying(true)).catch(() => {});
          window.removeEventListener("click", startBg);
        };
        window.addEventListener("click", startBg);
      });

    // ✅ Scroll effect
    const playScrollFx = () => {
      if (playedScroll.current) return;
      playedScroll.current = true;
      scrollFx.currentTime = 0;
      scrollFx.volume = 0.2;
      scrollFx.play().catch(() => {});
      setTimeout(() => (playedScroll.current = false), 800);
    };

    window.addEventListener("scroll", playScrollFx);
    return () => window.removeEventListener("scroll", playScrollFx);
  }, []);

  // ✅ Toggle audio manually
  const handleToggleAudio = () => {
    const bg = bgAudioRef.current;
    const scrollFx = scrollAudioRef.current;
    if (!bg || !scrollFx) return;

    if (isPlaying) {
      bg.pause();
      scrollFx.pause();
      setIsPlaying(false);
    } else {
      bg.play().then(() => setIsPlaying(true)).catch(() => {});
      // Don’t auto-play scrollFx; it’s handled on scroll
    }
  };

    const [flipped, setFlipped] = useState(null);

    const services = [
  {
    id: 1,
    title: "Home Automation",
    img: "/assets/img/home-automation.webp",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
    more: "Home automation allows you to control lights, appliances, and more with your smartphone or voice assistants."
  },
  {
    id: 2,
    title: "Security",
    img: "/assets/img/modern-lock.webp",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
    more: "Our security systems include CCTV, access control, and motion sensors for full protection."
  },
  {
    id: 3,
    title: "AV Solution",
    img: "/assets/img/av-solution.webp",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
    more: "AV solutions provide immersive sound and video experiences for home and office environments."
  }
];

 const [engineReady, setEngineReady] = useState(false);

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine); // load the minimal engine
    }).then(() => {
      setEngineReady(true);
    });
  }, []);

 
  // 👇 OUTSIDE any component
const particlesOptions = {
  background: { color: { value: "white" } },
  fpsLimit: 60,
  interactivity: {
    events: {
      onHover: { enable: true, mode: "repulse" },
      onClick: { enable: true, mode: "push" },
    },
    modes: {
      repulse: { distance: 100, duration: 0.4 },
      push: { quantity: 3 },
    },
  },
  particles: {
    color: { value: "#f6ff00ff" },
    links: {
      // color: "#2d3058ff",
          color: "#ffffffff",
      distance: 120,
      enable: true,
      // opacity: 0.3,
      opacity: 1,
       width: 1,
    },
    move: {
      enable: true,
      speed: 1,
      outModes: { default: "bounce" },
    },
    number: { value: 150, density: { enable: true, area: 100 } },
    opacity: { value: 0.3 },
    shape: { type: "circle" },
    size: { value: { min: 1, max: 3 } },
  },
  detectRetina: true,
};


  function Counter({ to = 0, duration = 1.2, suffix = "", decimals = 0 }) {
  const ref = React.useRef(null);
  const inView = useInView(ref, { once: true, margin: "0px 0px -20% 0px" });
  const [value, setValue] = React.useState(0);

  React.useEffect(() => {
    if (!inView) return;
    const controls = animate(0, to, {
      duration,
      ease: "easeOut",
      onUpdate: (v) => {
        const factor = Math.pow(10, decimals);
        setValue(Math.round(v * factor) / factor);
      },
    });
    return () => controls.stop();
  }, [inView, to, duration, decimals]);

  return (
    <span ref={ref}>
      {value.toLocaleString(undefined, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      })}
      {suffix}
    </span>
  );
}


const testimonialDate =[
  {
    id: 1,
    name: "Rahul Sharma",
    message:
      "Working with Altima has been an incredibly smooth and rewarding experience. Their team understood our office security requirements perfectly and suggested solutions that were both practical and advanced. The installation process was handled professionally, with clear communication at every stage. What impressed me most was the way they explained each feature and ensured we were fully comfortable using the system. Ever since the upgrade, our staff feels safer and our overall monitoring is far more efficient. I would highly recommend Altima to anyone looking for reliable and intelligent security systems.",
  },

  {
    id: 2,
    name: "Neha Verma",
    message:
      "Altima has truly exceeded our expectations. Their perimeter security solution has made a huge difference to our residential property. From the very first consultation, the team was transparent, knowledgeable, and extremely patient in answering all our questions. The quality of their equipment is top-notch and the response time has been exceptional. We’ve already noticed a major improvement in safety and awareness around our premises. Their after-sales support is just as impressive—always available, polite, and very helpful. I am extremely satisfied and confidently recommend Altima to others.",
  },

  {
    id: 3,
    name: "Amit Gupta",
    message:
      "The level of professionalism and expertise that Altima brought to our home automation project was outstanding. They handled everything from planning to installation with great attention to detail. The automation system is seamless, intuitive, and has genuinely improved our everyday comfort. Whether it’s lighting, security, or AV integration, everything works perfectly in sync. What truly sets Altima apart is the way they prioritize customer convenience—they ensure everything is simple to use and customized to your lifestyle. It was one of the best investments we made for our home.",
  },

  {
    id: 4,
    name: "Priya Singh",
    message:
      "We hired Altima for a complete AV transformation of our conference room, and the outcome was beyond impressive. The sound clarity, display quality, and overall design have elevated the professional experience for our entire team. Their engineers are highly skilled and take the time to understand the exact requirements before recommending solutions. The project was completed on time, and the training provided afterward made everything very easy to operate. Even guests who visit our office frequently compliment the setup. Altima stands out for its exceptional quality, service, and long-term reliability.",
  }
];


 
  const blogData = [
  {
    id: 1,
    image: "/assets/img/home-automation.webp",
    date: "Jan 20, 2025",
    title: "How To Trust Your Intuition When You’re Making A Decision",
    author: "Altima Global",
    link: "#"
  },
  {
    id: 2,
    image: "/assets/img/home-automation.webp",
    date: "Feb 15, 2025",
    title: "The Science of Happiness: 10 Ways to Boost Your Mood",
    author: "Altima Global",
    link: "#"
  },
  {
    id: 3,
    image: "/assets/img/home-automation.webp",
    date: "Mar 5, 2025",
    title: "Mastering Time Management for Busy People",
    author: "Altima Global",
    link: "#"
  }
];


const PARTNER_BRANDS = [
  { id: 1, name: "Brand One", logo: "https://www.pngall.com/wp-content/uploads/15/Amazon-Logo-White.png" },
  { id: 2, name: "Brand Two", logo: "https://www.pngall.com/wp-content/uploads/15/Amazon-Logo-White.png" },
  { id: 3, name: "Brand Three", logo: "https://www.pngall.com/wp-content/uploads/15/Amazon-Logo-White.png" },
  { id: 4, name: "Brand Four", logo: "https://www.pngall.com/wp-content/uploads/15/Amazon-Logo-White.png" },
  { id: 5, name: "Brand Five", logo: "https://www.pngall.com/wp-content/uploads/15/Amazon-Logo-White.png" },
  { id: 6, name: "Brand Six", logo: "https://www.pngall.com/wp-content/uploads/15/Amazon-Logo-White.png" },
];

const FAQ_DATA = [
  {
    id: 1,
    question: "What kind of solutions does Altima provide?",
    answer:
      "We provide end-to-end Security, AV and Home Automation solutions including perimeter security, CCTV surveillance, access control, fire systems, auditorium AV, commercial cinema and fully integrated smart home experiences."
  },
  {
    id: 2,
    question: "Do you handle both design and installation?",
    answer:
      "Yes. Our team handles complete solution design, product selection, wiring layouts, installation, configuration and final handover. We also train your staff or family members to operate the system with ease."
  },
  {
    id: 3,
    question: "Can the systems be integrated with existing infrastructure?",
    answer:
      "In most cases, yes. We assess your current infrastructure and suggest the best way to integrate new systems with existing cabling, devices and networks to avoid unnecessary replacement costs."
  },
  {
    id: 4,
    question: "Do you provide post-installation support and maintenance?",
    answer:
      "Absolutely. We offer AMC and on-call support options. Our engineers are available for health checks, firmware upgrades, troubleshooting and future enhancements as your needs evolve."
  },
  {
    id: 5,
    question: "Do you work on residential, commercial and institutional projects?",
    answer:
      "Yes. We work with luxury homes, offices, schools, colleges, hotels, hospitals, auditoriums and industrial facilities—designing custom solutions based on the use-case and budget."
  }
];


const AWARDS = [
  {
    id: 1,
    title: "ISO 9001:2015 Certified",
    image: "/assets/img/award.png",
  },
  {
    id: 2,
    title: "Best Automation Integrator Award 2023",
    image: "/assets/img/award.png",
  },
  {
    id: 3,
    title: "Authorized Partner Certification",
    image: "/assets/img/award.png",
  },
  {
    id: 4,
    title: "Industry Excellence Badge",
    image: "/assets/img/award.png",
  },
  
];

 
 const FEATURED_PRODUCTS = [
  {
    id: 1,
    title: "Video Surveillance Systems (CCTV)",
    category: "Security",
    image: "/assets/img/home-automation.webp",
    description:
      "Hanwha • Tyco American Dynamics • Panasonic • Honeywell • ANPR Cam • Remote Monitoring – Milestone & Genetec",
  },
  {
    id: 2,
    title: "Fire Safety & Alarm Systems",
    category: "Fire & Life Safety",
    image: "/assets/img/av-solution.webp",
    description:
      "Fire Alarm System • Honeywell Fire • Simplex by Johnson Control • Verbena • Bosch Fire Alarm • PA Systems • Linear Heat Sensing for Cables",
  },
  {
    id: 3,
    title: "Home Automation Solutions",
    category: "Smart Living",
    image: "/assets/img/home-automation.webp",
    description:
      "Smart Lighting • Scene-Based Controls • Motion Sensors • App & Voice Automation • Smart Thermostats • Curtain & Blinds Automation • Wireless Networking",
  },
  {
    id: 4,
    title: "Access Control & Attendance Systems",
    category: "Access Management",
    image: "/assets/img/av-solution.webp",
    description:
      "Biometric Systems • Face Access • Iris Access • Suprema • Idemia Morpho • Time Attendance Software • Integrated Access Solutions",
  },
];



const category = [
  {
    id: 1,
    title: "Aarav Mehta",
    role: "Founder & CEO",
    img: "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg",
    desc: "Vision-driven leader with 12+ years in tech & business transformation."
  },
  {
    id: 2,
    title: "Riya Sharma",
    role: "Head of Operations",
    img: "https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg",
    desc: "Ensures seamless execution, team management & operational efficiency."
  },
  {
    id: 3,
    title: "Kabir Singh",
    role: "Lead Full-Stack Developer",
    img: "https://images.pexels.com/photos/614810/pexels-photo-614810.jpeg",
    desc: "Expert in scalable web apps, system architecture & product engineering."
  },
  {
    id: 4,
    title: "Meera Patel",
    role: "UI/UX Lead",
    img: "https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg",
    desc: "Designs intuitive, modern & user-centered digital experiences."
  },
  {
    id: 5,
    title: "Dev Bhatt",
    role: "Marketing Head",
    img: "https://images.pexels.com/photos/2379005/pexels-photo-2379005.jpeg",
    desc: "Specialist in brand strategy, performance ads & digital storytelling."
  },
  {
    id: 6,
    title: "Simran Kaur",
    role: "Project Manager",
    img: "https://images.pexels.com/photos/1181686/pexels-photo-1181686.jpeg",
    desc: "Manages delivery, client communication & cross-functional teams."
  },
  {
    id: 7,
    title: "Aditya Verma",
    role: "Senior QA Engineer",
    img: "https://images.pexels.com/photos/3777943/pexels-photo-3777943.jpeg",
    desc: "Ensures product quality, testing & reliability across all releases."
  },
  {
    id: 8,
    title: "Natasha Jain",
    role: "Content Strategist",
    img: "https://images.pexels.com/photos/1181688/pexels-photo-1181688.jpeg",
    desc: "Creates engaging content, brand stories & marketing messaging."
  }
];




    return (
        <>
      <audio ref={bgAudioRef} src={spaceAudio} preload="auto" />
    
      {/* 🔊 short scroll sound */}
      <audio ref={scrollAudioRef} src={scrollSound} preload="auto" />

            <TestingHeader />


 <div className="hero-section py-0 position-relative overflow-hidden bg-white">
 
 
 
 <div className="container my-5">
  <div className="position-relative overflow-hidden rounded-4">
    {/* Background video */}
    <div className="ratio ratio-21x9">
      <video
        className="w-100 h-100 object-fit-cover"
        autoPlay
        muted
        loop
        playsInline
      >
        <source
          src="https://www.vivint.com/sites/default/files/video-thumbnails/2022-02/Smart%20Home%20Ecosystem%20-%20Product%20Vignette_1.mp4"
          type="video/mp4"
        />
      </video>
    </div>

    <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-25" />

    <div className="position-absolute top-50 start-50 translate-middle text-center text-white px-3">
        <h1 className="fw-semibold display-6 display-md-4">
          Altima Global 
      </h1>

      <div className="mb-3 text-uppercase small fw-semibold"> Innovative solutions for a smarter, sustainable digital future.
 </div>
    
      <button
        type="button"
        className="btn btn-light rounded-circle d-inline-flex align-items-center justify-content-center mt-4 p-3" style={{width:70,height:70}}
      >
        <i className="ri-play-fill fs-3" />
      </button>
    </div>
  </div>
</div>





 <section className="position-relative text-white  m-0 pt-4 pb-4"   >
 
 
  <div className="container position-relative py-5"  >
    <div className="row justify-content-between  align-items-center h-100">
      <div className="col-md-6">
        <div className="myheading mb-4  ">
        <h2 className='text-dark'>About <span className="text-Gradient">  Altima Global </span></h2>
        </div>
        <p className="fs-5 mb-4 text-dark ">
          We know that AV and home automation systems are “lifestyle” items that
          should be simple and reliable to operate every time. Today’s
          constantly changing technologies make it harder and harder to operate
          even a basic home theater in a box system. Let AV Automation design a
          system specifically tailored for you and your family. Our AV system
          design and installation experts can make sure that you get all of the
          functions you want in an easy-to-understand and operate system.
        </p>
        
        
      <a href='#' className="hologram-btn">
 <span>  CONTACT US TODAY </span>  <i className="ri-arrow-right-up-line fs-4 fw-light"/>
</a>

      </div>
      <div className="col-md-4">
        <img src="/assets/img/about-img.webp" className='w-100 rounded-4' />
      </div>
    </div>
  </div>
</section>




<div className="multicolumn multicolumn-page bg-white">
  <div className=' mt-50 mb-50'>

 
  <div className="container">

    <div className="multicolumn-inner">
      <div className='myheading'>

 
      <motion.h2   initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.3 }}    
    transition={{ duration: 0.5, delay: 0 }}
     className=' mb-4 pb-4 '> Meet Our  <span className='text-Gradient'> Team </span></motion.h2>
          </div>



<ul className="cards">
      {category.map((service) => (
           <li key={service}>
 <a href="" className="card  bg-light-dark ">
      <img
        src={service.img}
        className="card__image object-fit-cover "
        alt=""
        style={{marginBottom:70,aspectRatio:'1/1'}}

      />
      <div className="card__overlay">
        <div className="card__header">
          <svg className="card__arc" xmlns="http://www.w3.org/2000/svg">
            <path />
          </svg>

          <button class="button-category card__thumb position-relative"><i class="ri-arrow-right-up-long-line"></i></button>

        
          <div className="card__header-text">
            <h3 className="card__title">{service.title}</h3>
            <span className="card__status"> <i className="ri-flashlight-fill"/> {service.role}</span>
          </div>
        </div>
        <p className="card__description">
      {service.desc}
        </p>
      </div>
    </a>
           </li> ))}
 
 
</ul>
 

  </div>

   </div>
 
 
</div>

  
 

</div>



<div className="multicolumn multicolumn-page pt-50 pb-50 bg-white ">
  <div className="container py-4">

    <div className="multicolumn-inner">
      <div className='myheading'>

 
      <motion.h2   initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.3 }}    
    transition={{ duration: 0.5, delay: 0 }}
     className=' mb-4 pb-4 '> Why <span className="text-Gradient"> Choose Us </span></motion.h2>
          </div>

      <div  className="row product-grid mt-4">
        <motion.div
          className="col-xl-4 col-md-6 col-12  "
    initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.3 }}    

    transition={{ duration: 0.5, delay: 0 }}

        >
          <a
            className="multicolumn-card border bg-white "
            href="#"
            aria-label="View Service Details"
          >
            <motion.div   initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.3 }}    
      transition={{ duration: 0.5, delay: 0.1 }}
     className="card-icon">
       <motion.img   initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.3 }}    
    transition={{ duration: 0.5, delay: 0.2 }}
     src="/assets/img/trust.gif" width={40} className="p-0" />
            </motion.div>

            <motion.h2 initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.3 }}    
    transition={{ duration: 0.5, delay: 0.3 }}
     className="heading text-28 mt-3"> Why Trust ALTIMA </motion.h2>
            <motion.div  initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.3 }}    
    transition={{ duration: 0.5, delay: 0.4 }} className="text text-16">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod 
            tempor incididunt ut labore et dolore magna aliqua.  

            </motion.div>
            
          </a>
        </motion.div>
       

           <motion.div
          className="col-xl-4 col-md-6 col-12  "
    initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.3 }}    
    transition={{ duration: 0.5, delay: 0 }}

        >
          <a
            className="multicolumn-card border bg-white "
            href="#"
            aria-label="View Service Details"
          >
            <motion.div   initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.3 }}    
    transition={{ duration: 0.5, delay: 0.1 }}
     className="card-icon">
       <motion.img   initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.3 }}    
    transition={{ duration: 0.5, delay: 0.2 }}
     src="/assets/img/helpdesk.gif" width={40} className="p-0" />
            </motion.div>

            <motion.h2 initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.3 }}    
    transition={{ duration: 0.5, delay: 0.3 }}
     className="heading text-28 mt-3"> Customer Oriented </motion.h2>
            <motion.div  initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.3 }}    
    transition={{ duration: 0.5, delay: 0.4 }} className="text text-16">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod 
            tempor incididunt ut labore et dolore magna aliqua.  

            </motion.div>
           
           
          </a>
        </motion.div>
       


           <motion.div
          className="col-xl-4 col-md-6 col-12  "
    initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.3 }}    

    transition={{ duration: 0.5, delay: 0 }}

        >
          <a
            className="multicolumn-card border bg-white "
            href="#"
            aria-label="View Service Details"
          >
            <motion.div   initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.3 }}    

    transition={{ duration: 0.5, delay: 0.1 }}
     className="card-icon">
       <motion.img   initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.3 }}    

    transition={{ duration: 0.5, delay: 0.2 }}
     src="/assets/img/smartphone.gif" width={40} className="p-0" />
            </motion.div>

            <motion.h2 initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.3 }}    

    transition={{ duration: 0.5, delay: 0.3 }}
     className="heading text-28 mt-3"> Tech Enabled </motion.h2>
            <motion.div  initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.3 }}    

    transition={{ duration: 0.5, delay: 0.4 }} className="text text-16">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod 
            tempor incididunt ut labore et dolore magna aliqua.  

            </motion.div>
           
          


          </a>
        </motion.div>
       


      </div>
    </div>

  </div>
</div>






  
  <section className="multicolumn multicolumn-page bg-white"   >
      <div className="py-5">
        <div className="container">
          {/* Heading */}
          <div className="myheading mb-4  ">
            <motion.h3
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5 }}
              className="fw-bold mb-2 text-dark text-uppercase"
            >
             Our Core <span className="text-Gradient">Values </span> 
            </motion.h3>

            <motion.p
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="text-dark "
            >
              Revolutionizing Modern Living with Technology, Comfort, and Security
            </motion.p>
          </div>

          {/* Facts Row */}
          <div className="row text-center">
            {/* Card 1 */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="col-md-3 col-6 mb-4"
            >
              <div className="p-3 h-100 border rounded rounded-4 shadow-sm bg-white">
                 <img src="/assets/img/family-life.gif" style={{width:60}} className='mb-3 d-inline-block mx-auto'/>
                <h3 className="fw-bold mb-1">
                  <Counter to={5000} suffix="+" />
                </h3>
                <h6 className="fw-medium">Smart Homes Installed</h6>
                <p className="small text-muted mb-0">Across Major Cities in India</p>
              </div>
            </motion.div>

            {/* Card 2 */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: 0.25 }}
              className="col-md-3 col-6 mb-4"
            >
              <div className="p-3 h-100 border rounded rounded-4 shadow-sm bg-white">
                 <img src="/assets/img/green-energy.gif" style={{width:60}} className='mb-3 d-inline-block mx-auto'/>
                <h3 className="fw-medium mb-1">
                  <Counter to={99} suffix="%" />
                </h3>
                <h6 className="fw-semibold">Energy Efficiency</h6>
                <p className="small text-muted mb-0">Optimized Power-Saving Automation</p>
              </div>
            </motion.div>

            {/* Card 3 */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              className="col-md-3 col-6 mb-4"
            >
              <div className="p-3 h-100 border rounded rounded-4 shadow-sm bg-white">
                 <img src="/assets/img/phone-signal.gif" style={{width:60}} className='mb-3 d-inline-block mx-auto'/>
                <h3 className="fw-medium mb-1">
                  <Counter to={50} suffix="+" />
                </h3>
                <h6 className="fw-semibold">Devices Integrated</h6>
                <p className="small text-muted mb-0">Alexa, Google, Apple &amp; More</p>
              </div>
            </motion.div>

            {/* Card 4 (static label) */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: 0.35 }}
              className="col-md-3 col-6 mb-4"
            >
              <div className="p-3 h-100 border rounded rounded-4 shadow-sm bg-white">
                 <img src="/assets/img/smart-lock.gif" style={{width:60}} className='mb-3 d-inline-block mx-auto'/>
                <h3 className="fw-medium mb-1">24x7</h3>
                <h6 className="fw-semibold">Smart Security</h6>
                <p className="small text-muted mb-0">Monitoring &amp; Control Anytime</p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  

 
</div>

           
            <TestingFooter />
        </>

    );
};

export default TestingAbout